export function isValidTitle(title) {
  try {
    if (title && title.length > 0) {
      const wordOnTitle = title.split(" ").find((e) => e.length > 0);
      if (wordOnTitle) return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}
